/**
 * Asynchronously loads the component for ExamplePage
 */

import { lazyLoad } from 'utils/loadable';

export const Example = lazyLoad(
  () => import('./index'),
  module => module.default,
);
